// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WarningTwoToneSvg from "@ant-design/icons-svg/es/asn/WarningTwoTone";
import AntdIcon from '../components/AntdIcon';

var WarningTwoTone = function WarningTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WarningTwoToneSvg
  }));
};

WarningTwoTone.displayName = 'WarningTwoTone';
export default React.forwardRef(WarningTwoTone);